(function() {
'use strict';

angular
    .module('TR')
    .service('geo', geo);

function geo($http, $q, autocompleter) {
    const service = {
        getSearchArea,
        supported,
        getNearestAirportTitles,
        getNearestAirports
    };

    function getSearchArea() {
        const d = $q.defer();
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(function(pos) {
                d.resolve({
                    Latitude: pos.coords.latitude,
                    Longitude: pos.coords.longitude,
                    Radius: 10
                });
            }, function(err) {
                //this happens quite a lot but it is almost always because the user does not give permission
                //analytics.trackEvent({category : 'failure', action : 'geo', label:'getCurrentPositionFailed'});
                //loggingService.logWarn('geo.getCurrentPositionFailed with err: ' + JSON.stringify(err));
                d.reject(err);
            });
        } else {
            //having tracked this for a while, it pretty much never happens.
            //analytics.trackEvent({category : 'failure', action : 'geo', label:'geolocationNotSupported'});
            d.reject('geo not supported');
        }
        return d.promise;
    }

    function supported() {
        return navigator.geolocation;
    }

    function defaultClientLocation() {
        return angular.fromJson(TRPCONFIG.Domain.ClientDefaultLocation
            || '{ "CountryCode": "GB", "Latitude": 51.4167, "Longitude": -0.2833 }');
    }

    function getLocationFromIpAddress() {
        const isPrerender = /prerender/i.test(navigator.userAgent);
        if (isPrerender) {
            return $q.when([]);
        }
        let ipAddress = TRPCONFIG.ClientIpAddress;
        const url = `/api2/globalisation/location?${$.param({
            ipAddress
        })}`;
        return $http
            .get(url, { cache: true, ignoreErrors: true })
            .then(response => {
                let location = response.data;
                if (angular.equals(location, { CountryCode: null, Latitude: 0, Longitude: 0 })) {
                    location = defaultClientLocation();
                }
                return location;
            });
    }

    function getNearestAirports() {
        if (TRPCONFIG.Domain.NearestAirportsStaticList) {
            return $q.when(TRPCONFIG.Domain.NearestAirportsStaticList);
        }
        return getLocationFromIpAddress()
            .then(location => $q.all({
                airportValidator: getAirportValidator(),
                nearbyAirports: getAirportsNear(location)
            }))
            .then(({
                airportValidator,
                nearbyAirports
            }) => {
                let filter = airports => _(airports)
                    .filter(airportValidator)
                    .take(6)
                    .map(a => ({ Code: a }))
                    .value();

                nearbyAirports = filter(nearbyAirports);
                if (nearbyAirports && nearbyAirports.length) {
                    return nearbyAirports;
                }
                return getAirportsNear(defaultClientLocation())
                    .then(nearbyAirports => filter(nearbyAirports));
            })
            .catch(() => []);
    }

    function getNearestAirportTitles() {
        return getLocationFromIpAddress()
            .then(location => {
                const url = `website/flights/nearestairporttitles?${$.param({
                    cultureCode: TRPCONFIG.Domain.CultureCode,
                    latitude: location.Latitude,
                    longitude: location.Longitude
                })}`;
                return $http
                    .get(url, { cache: true, ignoreErrors: true })
                    .then(response => _.take(response.data, 6));
            });
    }

    function getAirportsNear(location) {
        let params = {
            latitude: location.Latitude,
            longitude: location.Longitude
        };
        if (TRPCONFIG.Domain.NearestAirportsMaxDistance) {
            params.maxDistance = TRPCONFIG.Domain.NearestAirportsMaxDistance;
        }
        const url = `/api2/flights/static/getnearestairports?${$.param(params)}`;
        return $http
            .get(url, { cache: true, ignoreErrors: true })
            .then(response => response.data);
    }

    function getAirportValidator() {
        if (TRPCONFIG.Domain.UseStaticDepartureDropdown) {
            return autocompleter.initialDepartureAirports().then(validAirports => {
                const validAirportCodes = _.map(validAirports.data, va => va.Code);
                return a => _.some(validAirportCodes, va => va === a);
            });
        }
        return $q.when(() => true);
    }

    return service;
}
})();
